/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".formcontainer .formgroup{margin:10px 0;box-sizing:border-box}.formcontainer .formgroup label{font-weight:700}.formcontainer button{margin:0 5px 0 0}.custom-required{color:red}.custom-error{display:block;color:red}.check-circle-gray{font-size:20px;color:gray}.check-circle-green{font-size:20px;color:#0c0!important}"];
export { styles as styles };
